import { render, staticRenderFns } from "./GenericView.vue?vue&type=template&id=4495eb9f&scoped=true"
import script from "./GenericView.vue?vue&type=script&lang=js"
export * from "./GenericView.vue?vue&type=script&lang=js"
import style0 from "./GenericView.vue?vue&type=style&index=0&id=4495eb9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495eb9f",
  null
  
)

export default component.exports